import { TweenMax } from 'gsap';

export default {
    methods: {
        shrinkLabel(labelClass, $event) {
            TweenMax.to('.' + labelClass, 0.25, {
                scale: 0.7,
                y: -12,
                x: 0,
                transformOrigin: 'top left',
            });          
        },

        growLabel(labelClass, $event) {
            if($event.target.value === '') {
                TweenMax.to('.' + labelClass, 0.25, {
                    scale: 1,
                    y: 0,
                    x: 0,
                    transformOrigin: 'top left',
                }); 
            }
        }
    }
}